/* eslint-disable no-mixed-operators */
import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Container, Card, FilledButton, OutlinedButton, BreadcrumbsWrapper, BreadcrumbsItem, ProgressIndicator, ProgressSpinner } from '@jsluna/react'
import { withRouter } from 'react-router-dom'
import DetailsCard from './DetailsCard'
import Constants from '../../../utils/constants'
import api from '../../../utils/api'
import { addSpacesToPhoneNo } from '../../../utils/common'
import RejectPassModal from './RejectPassModal'

class PassDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      modalOpen: false
    }
  }

  componentWillMount() {
    const { passDetails, actionRequired } = this.props
    if (passDetails === undefined || actionRequired === undefined) {
      window.location.href = '/passes'
    }
  }

  onAuthoriseOrSignOffClick = () => {
    const buttonText = this.getActionText()
    return buttonText === 'Authorise' ? this.authorisePasses('Authorise work') : this.signOffPasses()
  }

  getActionText = () => {
    const { actionRequired } = this.props
    return actionRequired === 'Sign off' ? 'Sign off' : 'Authorise'
  }

  reviewText = () => {
    const { passDetails } = this.props
    const actionText = this.getActionText().toLowerCase()
    return passDetails.length > 1 ? `Review and ${actionText} the passes` : `Review and ${actionText} the pass`
  }

  reviewTextAuthorised = () => {
    const { passDetails } = this.props
    return passDetails.length > 1 ? 'Authorised passes' : 'Authorised pass'
  }

  redirect = () => {
    const { history } = this.props
    history.push('/passes')
  }

  authorisePasses = (buttonText) => {
    const { history, passDetails } = this.props

    this.setState({ loading: true, loadingText: 'Authorising pass' })

    const authorisation = {
      actionTypeId: Constants.visitPassActionTypes.approved,
      visitPassIds: passDetails.map(a => a.visitPassId),
      visitId: passDetails[0].visitId,
      actionedOn: new Date(),
      buttonText
    }

    api.addVisitAction(authorisation).then((res) => {
      if (res) {
        history.goBack()
      }
    }).catch(() => { this.setState({ loading: false }) })
  }

  signOffPasses = () => {
    const { history, passDetails } = this.props

    this.setState({ loading: true, loadingText: 'Signing off work...' })

    const visitId = passDetails[0].visitId
    const buttonText = document.getElementById('Sign off').innerHTML

    api.addSignOffPassesAsync(visitId, buttonText)
      .then((res) => {
        if (res) {
          history.goBack()
        }
      }).catch(() => this.setState({ loading: false }))
  }

  rejectWorkOrder = () => {
    const { history, passDetails } = this.props

    this.setState({ loading: true, loadingText: 'Rejecting work...' })

    const buttonText = document.getElementById('reject work').innerHTML
    const data = {
      actionTypeId: Constants.visitPassActionTypes.rejected,
      visitPassIds: passDetails.map(a => a.visitPassId),
      visitId: passDetails[0].visitId,
      actionedOn: new Date(),
      buttonText
    }

    api.addVisitAction(data).then((res) => {
      if (res) {
        history.goBack()
      }
    }).catch(() => { this.setState({ loading: false }) })
  }

  render() {
    const { passDetails, actionRequired } = this.props
    const { loading, loadingText, modalOpen } = this.state

    return (
      <div>
        <RejectPassModal open={modalOpen} yesClicked={this.rejectWorkOrder} noClicked={() => this.setState({ modalOpen: false })} />
        <div className="ln-c-header-body" id="main-content">
          <ProgressIndicator page loading={loading}>
            <ProgressSpinner />
            {loadingText}
          </ProgressIndicator>
          <Container size="md">
            <BreadcrumbsWrapper narrow>
              <BreadcrumbsItem onClick={() => this.redirect()}>
                Passes
              </BreadcrumbsItem>
              {actionRequired === 'Authorisation' || actionRequired === 'Sign off' &&
                <BreadcrumbsItem active>
                  {this.getActionText()} work
                </BreadcrumbsItem>}
              {actionRequired === 'UnAuthorised' &&
              <BreadcrumbsItem active>
                {'Unauthorised Pass'}
              </BreadcrumbsItem>}
              {actionRequired === 'Authorised' &&
                <BreadcrumbsItem active>
                  {'Authorised Pass'}
                </BreadcrumbsItem>
              }
            </BreadcrumbsWrapper>
          </Container>
          <Container size="xs">
            <div className="u-device-padding">
              <h3>WO: {passDetails[0].WorkOrderNumber}</h3>
              <p className="ln-u-margin-bottom*2">{passDetails[0].WorkOrderDescription}</p>
              <p className="ln-u-margin-bottom">WO for: <b>{passDetails[0].WorkOrderCompanyName}</b></p>
              <p className="ln-u-margin-bottom">Contractor: <b>{`${passDetails[0].Forename} ${passDetails[0].Surname}`}</b></p>
              <p className="ln-u-margin-bottom">Company: <b>{passDetails[0].CompanyName}</b></p>
              <p className="ln-u-margin-bottom">Phone: <b>{addSpacesToPhoneNo(passDetails[0].PhoneNumber)}</b></p>
              <p className="ln-u-margin-bottom">Site name: <b>{passDetails[0].Site.SiteName.padStart(4, '0')}</b></p>
              <p className="ln-u-margin-bottom*2">Site code: <b>{passDetails[0].Site.SiteCode.padStart(4, '0')}</b></p>
            </div>
          </Container>
          <Container size="xs">
            <Card>
              {actionRequired === 'Authorisation' && 
              this.reviewText()}
              {actionRequired === 'Sign off' && 
              this.reviewText()}
              {actionRequired === 'Authorised' &&
              this.reviewTextAuthorised()}
            </Card>
            <DetailsCard passDetails={passDetails} actionRequired={actionRequired} />
            <Card className="ln-u-hard-top">
              {actionRequired === 'Authorisation' && 
              <FilledButton
                fullWidth
                className="ln-u-margin-bottom*2"
                onClick={() => this.onAuthoriseOrSignOffClick()}
                id={this.getActionText()}
              >
                {this.getActionText()} work
              </FilledButton>}
              {actionRequired === 'Sign off' && 
              <FilledButton
                fullWidth
                className="ln-u-margin-bottom*2"
                onClick={() => this.onAuthoriseOrSignOffClick()}
                id={this.getActionText()}
              >
                {this.getActionText()} work
              </FilledButton>}
              {
                actionRequired === 'Authorisation' &&
                <OutlinedButton id="reject work" fullWidth onClick={() => this.setState({ modalOpen: true })}>
                  Reject work
                </OutlinedButton>
              }
            </Card>
          </Container>
        </div>
      </div>
    )
  }
}

PassDetails.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  passDetails: PropTypes.arrayOf(PropTypes.shape({
    WorkOrderNumber: PropTypes.string.isRequired,
    WorkOrderDescription: PropTypes.string.isRequired,
    WorkOrderCompanyName: PropTypes.string.isRequired,
    Forename: PropTypes.string.isRequired,
    Surname: PropTypes.string.isRequired,
    CompanyName: PropTypes.string.isRequired,
    PhoneNumber: PropTypes.string.isRequired
  })),
  actionRequired: PropTypes.string.isRequired
}

PassDetails.defaultProps = {
  passDetails: []
}

export default withRouter(PassDetails)



// WEBPACK FOOTER //
// ./src/components/Passes/PassDetails/PassDetails.jsx